import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import MyTeamInterface from "./MyTeamInterface";
// Define a type for the slice state

// Define the initial state using that type

const dashboardCalendarSlice = createSlice({
  name: "calendar",

  initialState: { calendar: [], dashboardCalendarLoader: false },
  reducers: {
    setCalendarData: (state: any, action: PayloadAction<any>) => {
      state.calendar = action.payload;
    },
    setDashboardCalendarLoader: (state: any, action: PayloadAction<any>) => {
      state.dashboardCalendarLoader = action.payload;
    },
    resetCalendarData: (state: any) => {
      state.calendar = [];
    },
  },
});

export const {
  setCalendarData,
  resetCalendarData,
  setDashboardCalendarLoader,
} = dashboardCalendarSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default dashboardCalendarSlice.reducer;
